import React from "react";
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

const EvolutionLabel = ({value}) => {
    //Set arrow color according to the value
    const arrowColor = value > 0  ? '#008631' : value < 0 ? '#ff4d4f' : '#000000';
    //Set arrow icon according to the value
    const arrowIcon = value > 0 ? <ArrowUpOutlined/> : value < 0 ? <ArrowDownOutlined/> : ' ';
    //Formatated value
    const formatedValue = Math.abs(value).toFixed(0);

    return (
        <span style={{color: arrowColor, fontSize: '12px'}}>
            {arrowIcon}{`${formatedValue}%`}
        </span>
    )
};

export default EvolutionLabel;